import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Constants } from '../shared/constants';
import { AffectingBrandData, AffectingCompanyData, AffectingMasterBrandData, AffectingProductData, AffectingSubBrandData, EditDropdownModel, ProductMasterDataModel, ProductSizeGridModel, RenameDataModel } from '../shared/models/product.model';

@Injectable({
  providedIn: 'root'
})
export class MasterDataEditService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/masterdatagridedit';

  constructor(private httpClient: HttpClient) { }

  public getCompany(): Observable<EditDropdownModel[]> {
	return this.httpClient
		.get<EditDropdownModel[]>(this.url + `/getCompany`, { headers: this.headers });
  }

  public getMasterBrand(companyId): Observable<EditDropdownModel[]> {
	return this.httpClient
		.get<EditDropdownModel[]>(this.url + `/getMasterBrand/${companyId}`, { headers: this.headers });
  }

  public getBrand(companyId, masterBrandId): Observable<EditDropdownModel[]> {
	return this.httpClient
		.get<EditDropdownModel[]>(this.url + `/getBrand/${companyId}/${masterBrandId}`, { headers: this.headers });
  }

  public getSubBrand(companyId, masterBrandId, brandId): Observable<EditDropdownModel[]> {
	return this.httpClient
		.get<EditDropdownModel[]>(this.url + `/getSubBrand/${companyId}/${masterBrandId}/${brandId}`, { headers: this.headers });
  }

  public getProduct(companyId, masterBrandId, brandId, subBrandId): Observable<EditDropdownModel[]> {
	return this.httpClient
		.get<EditDropdownModel[]>(this.url + `/getProduct/${companyId}/${masterBrandId}/${brandId}/${subBrandId}`, { headers: this.headers });
  }

  public getCategory(): Observable<EditDropdownModel[]> {
	return this.httpClient
		.get<EditDropdownModel[]>(this.url + `/getCategory`, { headers: this.headers });
  }

  public getSubcategoryFunction(categoryId): Observable<EditDropdownModel[]> {
	return this.httpClient
		.get<EditDropdownModel[]>(this.url + `/getSubcategoryFunction/${categoryId}`, { headers: this.headers });
  }

  public getSubcategoryForm(categoryId, subcategoryFunctionId): Observable<EditDropdownModel[]> {
	return this.httpClient
		.get<EditDropdownModel[]>(this.url + `/getSubcategoryForm/${categoryId}/${subcategoryFunctionId}`, { headers: this.headers });
  }

  public getProductSizeOnLabel(): Observable<ProductSizeGridModel[]> {
	return this.httpClient
		.get<ProductSizeGridModel[]>(this.url + `/getProductSizeOnLabel`, { headers: this.headers });
  }

  // company renaming
  public getAfftectedCompanyNameData(selectedEditCompanyOldName): Observable<AffectingCompanyData[]> {
	return this.httpClient
		.get<AffectingCompanyData[]>(this.url + `/getAfftectedCompanyNameData/${selectedEditCompanyOldName}`, { headers: this.headers });
  }

  public getExistingCompanyNameData(selectedEditCompanyNewName): Observable<AffectingCompanyData[]> {
	return this.httpClient
		.get<AffectingCompanyData[]>(this.url + `/getExistingCompanyNameData/${selectedEditCompanyNewName}`, { headers: this.headers });
  }

  public updateCompanyName(data: RenameDataModel) {
	return this.httpClient
		.post(this.url + `/updateCompanyName`, data, { headers: this.headers });
  }

  // master brand renaming
  public getAffectingMasterBrandData(selectedEditMasterBrandOldName): Observable<AffectingMasterBrandData[]> {
	return this.httpClient
		.get<AffectingMasterBrandData[]>(this.url + `/getAffectingMasterBrandData/${selectedEditMasterBrandOldName}`, { headers: this.headers });
  }

  public getExistingMasterBrandData(selectedEditMasterBrandNewName): Observable<AffectingMasterBrandData[]> {
	return this.httpClient
		.get<AffectingMasterBrandData[]>(this.url + `/getExistingMasterBrandData/${selectedEditMasterBrandNewName}`, { headers: this.headers });
  }

  public updateMasterBrandName(data: RenameDataModel) {
	return this.httpClient
		.post(this.url + `/updateMasterBrandName`, data, { headers: this.headers });
  }

  // brand renaming
  public getAffectingBrandData(selectedEditBrandOldName): Observable<AffectingBrandData[]> {
	return this.httpClient
		.get<AffectingBrandData[]>(this.url + `/getAffectingBrandData/${selectedEditBrandOldName}`, { headers: this.headers });
  }

  public getExistingBrandData(selectedEditBrandNewName): Observable<AffectingBrandData[]> {
	return this.httpClient
		.get<AffectingBrandData[]>(this.url + `/getExistingBrandData/${selectedEditBrandNewName}`, { headers: this.headers });
  }

  public updateBrandName(data: RenameDataModel) {
	return this.httpClient
		.post(this.url + `/updateBrandName`, data, { headers: this.headers });
  }

  // sub-brand renaming
  public getAffectingSubBrandData(selectedEditSubBrandOldName): Observable<AffectingSubBrandData[]> {
	return this.httpClient
		.get<AffectingSubBrandData[]>(this.url + `/getAffectingSubBrandData/${selectedEditSubBrandOldName}`, { headers: this.headers });
  }

  public getExistingSubBrandData(selectedEditSubBrandNewName): Observable<AffectingSubBrandData[]> {
	return this.httpClient
		.get<AffectingSubBrandData[]>(this.url + `/getExistingSubBrandData/${selectedEditSubBrandNewName}`, { headers: this.headers });
  }

  public updateSubBrandName(data: RenameDataModel) {
	return this.httpClient
		.post(this.url + `/updateSubBrandName`, data, { headers: this.headers });
  }

  // product renaming
  public getAffectingProductData(selectedEditProductOldName): Observable<AffectingProductData[]> {
	return this.httpClient
		.get<AffectingProductData[]>(this.url + `/getAffectingProductData/${selectedEditProductOldName}`, { headers: this.headers });
  }

  public getExistingProductData(selectedEditProductOldName): Observable<AffectingProductData[]> {
	return this.httpClient
		.get<AffectingProductData[]>(this.url + `/getExistingProductData/${selectedEditProductOldName}`, { headers: this.headers });
  }

  public updateProductName(data: RenameDataModel) {
	return this.httpClient
		.post(this.url + `/updateProductName`, data, { headers: this.headers });
  }

  // createOrModifyProductMaster
  public createOrModifyProductMaster(data: ProductMasterDataModel) {
	return this.httpClient
		.post(this.url + `/createOrModifyProductMaster`, data, { headers: this.headers });
  }
}
